/* ============================================================
 * Quiz de Pele — Rosa Selvagem
 * 100% client-side. Uma instância por seção (.rs-quiz).
 * Lê os produtos de um <script type="application/json"> renderizado
 * pelo Liquid (metaobjetos). Sem dados → usa DEMO_DATA (preview).
 * Add-to-cart reusa o padrão do tema (cart-cross.js):
 *   /cart/add.js → re-render #minicart-form → cart-notification.open()
 * ============================================================ */
(function () {
  'use strict';

  /* ---- Ícones das missões (rosa #F9106E) — do protótipo ---- */
  var ICONS = {
    foliculite: '<svg width="28" height="28" viewBox="0 0 64 64" fill="#F9106E" xmlns="http://www.w3.org/2000/svg"><g><path d="m32 46c8.173 0 12.199-8.261 8.835-15.453l-7.93-16.971c-.357-.767-1.454-.768-1.812 0l-7.931 16.97c-3.345 7.156.62 15.454 8.838 15.454zm-7.025-14.606 7.025-15.032 7.024 15.032c2.697 5.766-.183 12.606-7.024 12.606-6.739 0-9.764-6.746-7.025-12.606z"/><path d="m29.619 41.586c1.236.466 1.942-1.41.7-1.873-1.517-.567-2.319-1.906-2.319-3.873 0-.777.138-1.563.4-2.273.459-1.242-1.419-1.933-1.876-.692-.343.928-.524 1.954-.524 2.965 0 3.824 2.267 5.241 3.619 5.746z"/><path d="m30.708 28.573 1.254-2.683c.561-1.2-1.253-2.045-1.812-.847l-1.254 2.683c-.562 1.204 1.253 2.042 1.812.847z"/><path d="m59 19h-14.042c-2.894 0-4.802 3.006-3.579 5.625 1.397 3.449 3.621 6.19 3.621 11.215 0 7.502-5.589 13.16-13 13.16s-13-5.658-13-13.16c0-5.04 2.2-7.707 3.621-11.216 1.225-2.622-.69-5.624-3.579-5.624h-14.042c-1.322 0-1.324 2 0 2h14.042c1.429 0 2.371 1.484 1.767 2.777-1.366 3.408-3.809 6.478-3.809 12.063 0 8.642 6.449 15.16 15 15.16s15-6.518 15-15.16c0-5.593-2.438-8.644-3.809-12.063-.284-.608-.239-1.309.121-1.874s.975-.903 1.646-.903h14.042c1.322 0 1.324-2 0-2z"/></g></svg>',
    clarear_virilha: '<svg width="28" height="28" viewBox="0 0 24 24" fill="#F9106E" xmlns="http://www.w3.org/2000/svg"><path d="m12.243 19h-.589c-1.137 0-2.124-.744-2.4-1.81-.849-3.259-3.58-5.867-8.349-7.972-.55-.242-.905-.781-.905-1.372v-1.346c0-.827.673-1.5 1.5-1.5h21c.827 0 1.5.673 1.5 1.5v1.346c0 .591-.355 1.13-.905 1.373-4.769 2.104-7.5 4.712-8.35 7.972-.28 1.082-1.286 1.809-2.502 1.809zm-10.743-13c-.275 0-.5.224-.5.5v1.346c0 .195.121.375.31.458 5.065 2.236 7.981 5.061 8.912 8.635.162.625.751 1.061 1.432 1.061h.589c.753 0 1.37-.426 1.534-1.061.932-3.575 3.848-6.4 8.913-8.636.189-.082.31-.262.31-.457v-1.346c0-.276-.225-.5-.5-.5z"/></svg>',
    clarear_axilas: '<svg width="28" height="28" viewBox="0 0 512 512" fill="#F9106E" xmlns="http://www.w3.org/2000/svg"><path d="m166.787 72.34h207.059v21.224c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-25.041c0-1.565 1.273-2.838 2.838-2.838h32.277c1.564 0 2.838 1.273 2.838 2.838v18.924c0 29.155 23.72 52.875 52.875 52.875h24.826c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-24.826c-20.885 0-37.875-16.99-37.875-37.875v-18.817c18.762-6.24 32.784-22.544 35.828-42.506l1.98-12.982c.625-4.095-2.188-7.92-6.283-8.545-4.077-.625-7.92 2.188-8.545 6.283l-1.98 12.982c-2.274 14.91-13.068 26.979-27.35 31.036-3.107-2.624-7.113-4.213-11.488-4.213h-32.277c-5.603 0-10.604 2.602-13.877 6.655h-211.02c-4.143 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z"/><path d="m7.5 72.34h123.892c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-123.892c-4.143 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z"/><path d="m377.964 281.681c3.792-1.667 5.515-6.093 3.847-9.884-3.97-9.031-5.983-19.581-5.983-31.356 0-11.261 1.863-23.354 5.39-34.972 5.063-16.679 7.629-34.6 7.629-53.267v-23.242c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v23.242c0 11.966-1.165 23.565-3.42 34.666-15.938.186-33.525-1.434-51.231-4.777-10.219-1.929-20.969-5.18-31.949-9.663-36.68-14.973-74.562-24.533-112.594-28.416l-166.391-16.988c-4.113-.416-7.802 2.579-8.223 6.7s2.578 7.802 6.699 8.223l166.39 16.986c36.607 3.737 73.095 12.949 108.447 27.381 11.911 4.862 23.632 8.4 34.836 10.515 17.218 3.251 34.386 4.962 50.233 5.055-3.8 12.778-5.817 26.089-5.817 38.556 0 13.867 2.44 26.448 7.253 37.394 1.235 2.81 3.984 4.483 6.869 4.483 1.008 0 2.034-.205 3.015-.636z"/><path d="m504.5 362.631c-34.687 0-67.288-9.674-83.635-15.441-.942-.333-1.343-1.05-1.498-1.448-.155-.399-.346-1.2.124-2.083l12.313-23.158c2.469.187 4.97.287 7.49.287 17.766 0 34.509-7.027 48.419-20.322 2.995-2.862 3.103-7.609.24-10.604-2.862-2.994-7.61-3.103-10.604-.24-11.066 10.576-24.226 16.166-38.056 16.166-3.66 0-7.257-.244-10.739-.702-.007-.001-.013-.003-.02-.004-10.072-1.329-19.057-4.526-26.705-9.502-3.471-2.259-8.117-1.276-10.376 2.196-2.26 3.472-1.276 8.118 2.195 10.377 6.77 4.404 14.313 7.683 22.523 9.795l-9.926 18.667c-1.771 3.331-2.396 7.1-1.857 10.76-43.055 94.703-32.383 151.702-31.904 154.095.713 3.563 3.839 6.02 7.34 6.02.481 0 .971-.047 1.461-.143 4.055-.798 6.698-4.738 5.912-8.796-.102-.529-9.457-52.182 27.6-137.663.357.153.708.317 1.077.447 17.251 6.086 51.703 16.295 88.625 16.295 4.143 0 7.5-3.358 7.5-7.5s-3.356-7.499-7.499-7.499z"/></svg>',
    estrias: '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 10 Q12 8 16 12 Q20 16 24 14" stroke="#F9106E" stroke-width="1.5" stroke-linecap="round"/><path d="M6 14 Q10 12 14 16 Q18 20 22 18" stroke="#F9106E" stroke-width="1.5" stroke-linecap="round"/><path d="M8 18 Q11 16 15 20 Q18 23 21 22" stroke="#F9106E" stroke-width="1.5" stroke-linecap="round"/></svg>',
    linhas_finas: '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 14 Q8 9 12 14 Q16 19 20 14 Q22 11.5 24 14" stroke="#F9106E" stroke-width="1.5" stroke-linecap="round"/></svg>',
    ressecamento: '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 5 C14 5 7 13 7 17 A7 7 0 0 0 21 17 C21 13 14 5 14 5Z" stroke="#F9106E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    cicatrizes: '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="5" y1="14" x2="23" y2="14" stroke="#F9106E" stroke-width="1.5" stroke-linecap="round"/><line x1="12" y1="10" x2="12" y2="18" stroke="#F9106E" stroke-width="1.5" stroke-linecap="round"/><line x1="17" y1="10" x2="17" y2="18" stroke="#F9106E" stroke-width="1.5" stroke-linecap="round"/></svg>',
    manchas: '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="14" cy="14" r="10" stroke="#F9106E" stroke-width="1.5"/><ellipse cx="11" cy="11" rx="2" ry="1.3" fill="#F9106E" opacity="0.7"/><ellipse cx="17" cy="10" rx="1.5" ry="1" fill="#F9106E" opacity="0.7"/><ellipse cx="15" cy="15.5" rx="2.2" ry="1.4" fill="#F9106E" opacity="0.7"/><ellipse cx="10" cy="16" rx="1.3" ry="0.9" fill="#F9106E" opacity="0.7"/></svg>'
  };

  // As chaves (key) são os valores exatos gravados no metaobjeto (campo "queixa").
  var CONCERNS = [
    { key: 'Foliculite',                icon: ICONS.foliculite,     label: 'Foliculite' },
    { key: 'Clarear virilha ou axilas', icon: ICONS.clarear_axilas, label: 'Clarear virilha ou axilas' },
    { key: 'Estrias',                   icon: ICONS.estrias,        label: 'Estrias' },
    { key: 'Manchas',                   icon: ICONS.manchas,        label: 'Manchas' },
    { key: 'Linhas finas',              icon: ICONS.linhas_finas,   label: 'Linhas finas' },
    { key: 'Ressecamento',              icon: ICONS.ressecamento,   label: 'Ressecamento' }
  ];

  // key = valor exato gravado no metaobjeto (campo "aroma").
  var SCENTS_META = [
    { key: 'Cítrico',  emoji: '🍋', label: '🍋 Cítrico',  sub: 'Fresco, limpo, revitalizante' },
    { key: 'Frutado',  emoji: '🍓', label: '🍓 Frutado',  sub: 'Alegre, delicioso, vibrante' },
    { key: 'Doce',     emoji: '🍬', label: '🍬 Doce',     sub: 'Aconchegante, suave, marcante' },
    { key: 'Tropical', emoji: '🌴', label: '🌴 Tropical', sub: 'Exótico, sensual, inesquecível' }
  ];

  /* ---- DEMO_DATA: usado só quando não há metaobjetos (preview) ----
     variant_id null → compra desabilitada com aviso amigável. */
  function demoProd(title, cents) { return { variant_id: null, title: title, price: cents, image: '', url: '#' }; }
  var DEMO_DATA = {
    demo: true,
    recomendacoes: [
      { queixa: 'Foliculite',                tipo_pele: 'Qualquer',     kit: demoProd('Kit Pitaya + Íntimo + Sérum Candy + Óleo', 26990), entrada: demoProd('Óleo Clareador Corporal', 9990) },
      { queixa: 'Foliculite',                tipo_pele: 'Bem sensível', kit: demoProd('Kit Pitaya Suave — pele sensível', 25990),         entrada: demoProd('Óleo Calmante Corporal', 9490) },
      { queixa: 'Clarear virilha ou axilas', tipo_pele: 'Qualquer',     kit: demoProd('KIT Mc Mirella Clareador', 23990),                 entrada: demoProd('Sérum Candy Clareador Íntimo', 9700) },
      { queixa: 'Estrias',                   tipo_pele: 'Qualquer',     kit: demoProd('KIT Duplo Clareamento', 18690),                    entrada: demoProd('Óleo Clareador', 9990) },
      { queixa: 'Manchas',                   tipo_pele: 'Qualquer',     kit: demoProd('Niacinamida 25% + Bio-Retinol', 19400),            entrada: demoProd('Sérum Niacinamida 25%', 9700) },
      { queixa: 'Linhas finas',              tipo_pele: 'Qualquer',     kit: demoProd('Sérum Lifting + Bio-Retinol', 16699),              entrada: demoProd('Sérum Lifting Anti-Aging', 6999) },
      { queixa: 'Ressecamento',              tipo_pele: 'Qualquer',     kit: null,                                                        entrada: demoProd('Loção Ureia 10%', 6900) }
    ],
    aromas: {
      'Cítrico':  [ demoProd('Bruma Cítrica Revitalizante', 4900), demoProd('Hidratante Cítrico', 5900), demoProd('Sabonete Cítrico', 3900), demoProd('Óleo Cítrico', 6900), demoProd('Body Splash Cítrico', 5400), demoProd('Creme Cítrico', 5900) ],
      'Frutado':  [ demoProd('Bruma Frutas Vermelhas', 4900), demoProd('Creme Frutado', 5900), demoProd('Óleo Frutado', 6900), demoProd('Sabonete Frutado', 3900), demoProd('Hidratante Frutado', 5400), demoProd('Body Splash Frutado', 5400) ],
      'Doce':     [ demoProd('Bruma Doce Baunilha', 4900), demoProd('Hidratante Doce', 5900), demoProd('Sabonete Doce', 3900), demoProd('Óleo Doce', 6900), demoProd('Creme Doce Caramelo', 5900), demoProd('Body Splash Doce', 5400) ],
      'Tropical': [ demoProd('Bruma Tropical Coco', 4900), demoProd('Creme Tropical', 5900), demoProd('Óleo Tropical', 6900), demoProd('Sabonete Tropical', 3900), demoProd('Hidratante Tropical', 5400), demoProd('Body Splash Tropical', 5400) ]
    }
  };

  var STEPS = ['intro', 'p1', 'p2', 'p3', 'p4', 'result'];
  var TOTAL_STEPS = 5;
  var PROGRESS_MAP = { intro: 0, p1: 1, p2: 2, p3: 3, p4: 4, result: 5 };

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Fisher-Yates: embaralha uma cópia do array
  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  /* ============================================================
   * Uma instância do quiz
   * ============================================================ */
  function initQuiz(root) {
    if (!root || root.__rsQuizInit) return;
    root.__rsQuizInit = true;

    var stage = root.querySelector('[data-quiz-stage]');
    var progressWrap = root.querySelector('[data-quiz-progress]');
    var progressBar = root.querySelector('[data-quiz-progress-bar]');
    var dataEl = root.querySelector('[data-quiz-data]');
    if (!stage) return;

    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { DATA = null; }
    if (!DATA || !Array.isArray(DATA.recomendacoes) || !DATA.recomendacoes.length) DATA = DEMO_DATA;
    var isDemo = !!DATA.demo;

    // Normalização tolerante a maiúsculas/acentuação leve/espaços
    function norm(s) { return String(s == null ? '' : s).toLowerCase().trim().replace(/\s+/g, ' '); }
    function buildIndex(obj) { var m = {}; Object.keys(obj || {}).forEach(function (k) { m[norm(k)] = obj[k]; }); return m; }
    var AROMA_IDX = buildIndex(DATA.aromas);

    // Recomendação casada por (queixa × tipo de pele).
    // tipo_pele aceita: "" ou "Qualquer" (padrão p/ todos os tipos), um valor,
    // ou vários separados por vírgula (ex.: "Bem sensível, Um pouco, Tranquila").
    function tipoRank(entryTipo, sel) {
      var t = norm(entryTipo);
      if (t === '' || t === 'qualquer') return 1;                       // 1 = padrão (serve p/ todos)
      var parts = t.split(',').map(function (s) { return s.trim(); });
      return parts.indexOf(norm(sel)) !== -1 ? 2 : 0;                   // 2 = específico, 0 = não serve
    }
    function lookupRec() {
      var q = norm(QS.concern), sel = QS.sensitivity;
      var list = (DATA.recomendacoes || []).filter(function (r) { return norm(r.queixa) === q; });
      if (!list.length) {
        // tolerância: casa se a queixa cadastrada estiver contida na do quiz (ou vice-versa)
        list = (DATA.recomendacoes || []).filter(function (r) {
          var rq = norm(r.queixa);
          return rq && (q.indexOf(rq) !== -1 || rq.indexOf(q) !== -1);
        });
      }
      if (!list.length) return {};
      var best = list[0], bestRank = -1;                                // pega a melhor: específico > padrão > 1ª da queixa
      list.forEach(function (r) {
        var rk = tipoRank(r.tipo_pele, sel);
        if (rk > bestRank) { bestRank = rk; best = r; }
      });
      return best;
    }

    var CFG = {};
    try { CFG = JSON.parse(root.querySelector('[data-quiz-cfg]').textContent); } catch (e) { CFG = {}; }
    var L = {
      eyebrow: CFG.eyebrow || 'Quiz de Pele',
      titleHtml: CFG.title_html || 'Encontre sua<br><em>rotina perfeita</em>',
      sub: CFG.sub || '5 perguntas rápidas e a gente monta a rotina certa pra você — sem enrolação.',
      start: CFG.start_label || 'Começar',
      stepTratar: CFG.label_tratar || 'Tratar',
      stepPerfumar: CFG.label_perfumar || 'Perfumar',
      cta: CFG.cta_label || 'Adicionar rotina à sacola',
      showInstallments: CFG.show_installments !== false,
      installmentsCount: CFG.installments_count || 6,
      installmentsText: CFG.installments_text || '',
      showFreeship: CFG.show_freeship !== false,
      freeShipCents: CFG.free_ship_cents || 0,
      freeShipLabel: CFG.free_ship_label || '',
      showGift: CFG.show_gift !== false,
      giftCents: CFG.gift_cents || 0,
      giftLabel: CFG.gift_label || ''
    };

    /* ---- Estado ---- */
    var QS = { step: 'intro', concern: null, manchaLoc: null, sensitivity: null, routine: null, scent: null };
    var QR = { main: null, comps: [] };

    function money(cents) {
      cents = Math.round(cents || 0);
      try {
        if (window.Shopify && Shopify.formatMoney && window.cartStrings && cartStrings.money_format) {
          return Shopify.formatMoney(cents, cartStrings.money_format);
        }
      } catch (e) {}
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
    }

    /* ---- Progresso ---- */
    function setProgress(n) {
      if (!progressBar) return;
      if (progressWrap) progressWrap.classList.toggle('on', n > 0);
      progressBar.style.width = Math.round((n / TOTAL_STEPS) * 100) + '%';
    }

    /* ---- Navegação ---- */
    function navRow(stepLabel, prevStep) {
      return '<div class="quiz-nav">' +
        '<button class="quiz-nav-back" data-act="back" data-step="' + prevStep + '">' +
        '<span class="qnav-arrow">←</span> Voltar</button>' +
        '<span class="quiz-nav-step">' + escapeHtml(stepLabel) + '</span></div>';
    }

    /* ---- Telas ---- */
    function renderIntro() {
      return '' +
        '<div class="quiz-eyebrow">' + escapeHtml(L.eyebrow) + '</div>' +
        '<h1 class="quiz-title">' + L.titleHtml + '</h1>' +
        '<p class="quiz-sub">' + escapeHtml(L.sub) + '</p>' +
        '<button class="quiz-cta btn-pk" data-act="start" style="width:auto;padding:16px 40px;display:inline-flex;align-items:center;gap:10px">' +
        escapeHtml(L.start) +
        ' <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg></button>';
    }

    function renderP1() {
      var cards = CONCERNS.map(function (c, i) {
        return '<button class="qcard" data-act="concern" data-key="' + c.key + '" style="animation-delay:' + (i * 40) + 'ms">' +
          '<span class="qcard-icon">' + c.icon + '</span>' +
          '<span class="qcard-label">' + escapeHtml(c.label) + '</span></button>';
      }).join('');
      return navRow('Passo 1 de 5', 'intro') +
        '<h2 class="quiz-title">Qual é a sua<br><em>missão hoje?</em></h2>' +
        '<div class="quiz-grid">' + cards + '</div>';
    }

    function renderP2() {
      return navRow('Passo 2 de 5', 'p1') +
        '<h2 class="quiz-title">Sua pele é<br><em>sensível?</em></h2>' +
        '<div class="quiz-choices">' +
        '<button class="qchoice" data-act="sens" data-val="Bem sensível"><span class="qchoice-dot"></span>' +
        '<div class="qchoice-lbl">Bem sensível<div class="qchoice-sub">Fica vermelha, coça ou reage fácil</div></div></button>' +
        '<button class="qchoice" data-act="sens" data-val="Um pouco"><span class="qchoice-dot"></span>' +
        '<div class="qchoice-lbl">Um pouco<div class="qchoice-sub">Às vezes reage, mas nada grave</div></div></button>' +
        '<button class="qchoice" data-act="sens" data-val="Tranquila"><span class="qchoice-dot"></span>' +
        '<div class="qchoice-lbl">Tranquila<div class="qchoice-sub">Aguenta tudo sem reclamar</div></div></button>' +
        '</div>';
    }

    function renderP3() {
      return navRow('Passo 3 de 5', 'p2') +
        '<h2 class="quiz-title">Como você gosta<br><em>de se cuidar?</em></h2>' +
        '<div class="quiz-choices">' +
        '<button class="qchoice" data-act="routine" data-val="kit"><span class="qchoice-dot"></span>' +
        '<div class="qchoice-lbl">Rotina completa, quero resultado<div class="qchoice-sub">Kit com tudo que preciso de uma vez</div></div></button>' +
        '<button class="qchoice" data-act="routine" data-val="entrada"><span class="qchoice-dot"></span>' +
        '<div class="qchoice-lbl">Quero começar com um produto<div class="qchoice-sub">Menos compromisso, mais fácil de testar</div></div></button>' +
        '</div>';
    }

    function renderP4() {
      var opts = SCENTS_META.map(function (s) {
        return '<button class="qchoice" data-act="scent" data-val="' + s.key + '"><span class="qchoice-dot"></span>' +
          '<div class="qchoice-lbl">' + s.label + '<div class="qchoice-sub">' + escapeHtml(s.sub) + '</div></div></button>';
      }).join('');
      return navRow('Passo 4 de 5', 'p3') +
        '<h2 class="quiz-title">Qual cheirinho<br><em>é a sua cara?</em></h2>' +
        '<div class="quiz-choices">' + opts + '</div>';
    }

    /* ---- Seleções ---- */
    function selectConcern(key) { QS.concern = key; renderStep('p2'); }
    function selectSensitivity(v) { QS.sensitivity = v; renderStep('p3'); }
    function selectRoutine(v) { QS.routine = v; renderStep('p4'); }
    function selectScent(v) { QS.scent = v; renderStep('result'); }

    /* ============================================================
     * Resultado
     * ============================================================ */
    function baseConcernLabel() {
      var k = QS.concern || '';
      var found = CONCERNS.filter(function (c) { return c.key === k; })[0];
      return found ? found.label : (k || 'sua pele');
    }

    function imgHtml(it) {
      return it.image
        ? '<img src="' + escapeHtml(it.image) + '" alt="' + escapeHtml(it.name) + '" loading="lazy">'
        : '<div class="ph" style="height:100%"><span>' + escapeHtml(it.name) + '</span></div>';
    }

    // Monta o estado do resultado: 1 produto principal + até 5 cheirinhos (aroma escolhido)
    function buildResult() {
      var rec = lookupRec();
      // Produto principal: usa o kit se houver. No caminho "rotina completa" sem kit próprio,
      // monta um kit com 2 unidades do produto inicial.
      var mainProd = null, mainQty = 1, kitDupe = false;
      if (QS.routine === 'kit') {
        if (rec.kit) { mainProd = rec.kit; }
        else if (rec.entrada) { mainProd = rec.entrada; mainQty = 2; kitDupe = true; }
      } else {
        mainProd = rec.entrada || null;
      }
      if (!mainProd) mainProd = rec.kit || rec.entrada || null; // último recurso
      QR.main = mainProd ? {
        name: mainProd.title, price: mainProd.price, compare: mainProd.compare_at || 0, variant_id: mainProd.variant_id,
        image: mainProd.image || '', url: mainProd.url || '#', qty: mainQty, kitDupe: kitDupe, removed: false
      } : null;
      var list = AROMA_IDX[norm(QS.scent)] || [];
      if (!Array.isArray(list)) list = [list];
      QR.comps = shuffle(list.filter(Boolean)).slice(0, 4).map(function (p, i) {
        return { id: 'c' + i, name: p.title, price: p.price, compare: p.compare_at || 0, variant_id: p.variant_id, image: p.image || '', url: p.url || '#', selected: false };
      });
    }

    // Preço com comparação (de/por) quando há compare_at maior que o preço
    function priceHtml(it) {
      if (it.compare && it.compare > it.price) {
        return '<span class="qr-oldprice">' + money(it.compare) + '</span> ' + money(it.price);
      }
      return money(it.price);
    }
    function compareTotal() {
      var t = 0;
      if (mainActive()) t += (QR.main.compare > QR.main.price ? QR.main.compare : QR.main.price) * QR.main.qty;
      QR.comps.forEach(function (c) { if (c.selected) t += (c.compare > c.price ? c.compare : c.price); });
      return t;
    }

    function mainActive() { return QR.main && !QR.main.removed; }

    function resultTotal() {
      var t = mainActive() ? QR.main.price * QR.main.qty : 0;
      QR.comps.forEach(function (c) { if (c.selected) t += c.price; });
      return t;
    }

    function scentEmoji() {
      var m = SCENTS_META.filter(function (s) { return s.key === QS.scent; })[0];
      return m && m.emoji ? m.emoji : '🧴';
    }

    function renderResult() {
      buildResult();

      var micro = QS.sensitivity === 'Bem sensível'
        ? 'Fórmulas mais suaves, pensadas para pele sensível'
        : (QS.routine === 'kit' ? 'Rotina completa para resultados mais rápidos' : 'Produto certo para começar do jeito certo');

      var header = '<div class="qr-header" data-qr-hdr style="opacity:0;transform:translateY(10px);transition:opacity .4s,transform .4s">' +
        '<div class="qr-tag">Feito para você ✦</div>' +
        '<h2 class="qr-title">Sua rotina para <em>' + escapeHtml(baseConcernLabel().toLowerCase()) + '</em></h2>' +
        '<p class="qr-micro">' + escapeHtml(micro) + '</p></div>';

      if (!QR.main) {
        return '<div class="qr-wrap">' + header +
          '<div class="qr-sum-empty">Ainda não há produto configurado para esta combinação.<br>' +
          '<button class="quiz-restart" style="font-size:13px" data-act="restart">Refazer quiz</button></div></div>';
      }

      // Produto principal: círculo "1" + card com remover / stepper / desfazer
      var mainCard = '<div class="qr-step-row" data-qr-row="main">' +
        '<div class="qr-circle-num">1</div>' +
        '<div class="qr-step-h primary" style="padding-bottom:44px">' +
        '<button class="qr-remove-btn" data-act="main-remove" title="Remover" aria-label="Remover">&times;</button>' +
        '<div class="qr-step-img-sm">' + imgHtml(QR.main) + '</div>' +
        '<div class="qr-step-info">' +
        '<div class="qr-step-lbl">' + escapeHtml(L.stepTratar) + '</div>' +
        '<div class="qr-step-name">' + escapeHtml(QR.main.name) + '</div>' +
        '<div class="qr-step-desc">Trata ' + escapeHtml(baseConcernLabel().toLowerCase()) + ' com eficácia comprovada.' + (QR.main.kitDupe ? ' <strong>Kit com 2 unidades.</strong>' : '') + '</div>' +
        '<div class="qr-step-price">' + priceHtml(QR.main) + '</div>' +
        '</div>' +
        '<div class="qr-stepper">' +
        '<button class="qr-step-btn" data-act="main-dec" aria-label="Diminuir">−</button>' +
        '<span class="qr-step-qty" data-qr-mainqty>' + QR.main.qty + '</span>' +
        '<button class="qr-step-btn" data-act="main-inc" aria-label="Aumentar">+</button>' +
        '</div></div>' +
        '<div class="qr-ghost-row">' + escapeHtml(QR.main.name) + ' removido — <a data-act="main-undo">Desfazer</a></div>' +
        '</div>';

      // Cheirinhos: faixa horizontal de cards (até 4). "+" gira virando "×" quando adicionado.
      var scent = '';
      if (QR.comps.length) {
        var cards = QR.comps.map(function (c) {
          return '<button class="qr-scent-card' + (c.selected ? ' added' : '') + '" data-qr-comp="' + c.id + '" data-act="scent-toggle" data-id="' + c.id + '">' +
            '<div class="qr-scent-img">' + imgHtml(c) + '</div>' +
            '<div class="qr-scent-name">' + escapeHtml(c.name) + '</div>' +
            '<div class="qr-scent-price">' + priceHtml(c) + '</div>' +
            '<span class="qr-scent-add"><svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></span>' +
            '</button>';
        }).join('');
        scent = '<div class="qr-scent-block" data-qr-comp-sec>' +
          '<div class="qr-scent-head">' +
          '<span class="qr-scent-emoji">' + scentEmoji() + '</span>' +
          '<div><div class="qr-scent-title">Complemente com seu <em>cheirinho</em></div>' +
          '<div class="qr-scent-sub">Aroma ' + escapeHtml((QS.scent || '').toLowerCase()) + ' · toque para adicionar</div></div>' +
          '</div>' +
          '<div class="qr-scent-row">' + cards + '</div></div>';
      }

      var noteHtml = isDemo
        ? '<div class="qr-note" data-qr-note>Modo de demonstração — vincule os produtos nos metaobjetos para ativar a compra.</div>'
        : '<div class="qr-note" data-qr-note style="display:none"></div>';

      var summary = '<div class="qr-summary" data-qr-foot>' +
        '<div class="qr-summary-title">Sua rotina completa</div>' +
        '<div data-qr-summary></div>' +
        '<div class="qr-sum-divider"></div>' +
        '<div class="qr-sum-total"><span class="qr-sum-total-lbl">Total</span>' +
        '<span class="qr-sum-total-val" data-qr-total>' + money(resultTotal()) + '</span></div>' +
        '<div class="qr-installment" data-qr-installment></div>' +
        '<div class="qr-freeship" data-qr-freeship></div>' +
        '<div class="qr-giftbar" data-qr-gift></div>' +
        '<button class="qr-sum-cta" data-act="addcart" data-qr-cta>' + escapeHtml(L.cta) + '</button>' +
        noteHtml +
        '<div style="text-align:center;margin-top:8px"><button class="quiz-restart" data-act="restart">↺ Refazer quiz</button></div>' +
        '</div>';

      return '<div class="qr-wrap">' + header +
        '<div class="qr-cols">' +
        '<div class="qr-steps-v">' + mainCard + scent + '</div>' +
        summary +
        '</div></div>';
    }

    // Sincroniza o painel de resumo (lista + total + estado do botão)
    function syncSummary(noFlash) {
      var sumEl = stage.querySelector('[data-qr-summary]');
      var totalEl = stage.querySelector('[data-qr-total]');
      var ctaEl = stage.querySelector('[data-qr-cta]');
      if (!sumEl) return;
      var rows = [], anySel = false;
      if (mainActive()) {
        var mq = QR.main.qty > 1 ? (QR.main.qty + '× ') : '';
        rows.push('<div class="qr-sum-row"><span class="qr-sum-name">' + mq + escapeHtml(QR.main.name) + '</span><span class="qr-sum-price">' + money(QR.main.price * QR.main.qty) + '</span></div>');
      }
      QR.comps.forEach(function (c) {
        if (c.selected) { anySel = true; rows.push('<div class="qr-sum-row"><span class="qr-sum-name">' + escapeHtml(c.name) + '</span><span class="qr-sum-price">' + money(c.price) + '</span></div>'); }
      });
      if (!rows.length) rows.push('<div class="qr-sum-row" style="border:none;color:var(--gray)"><span class="qr-sum-name">Rotina vazia — adicione um item</span></div>');
      sumEl.innerHTML = rows.join('');
      if (ctaEl) ctaEl.disabled = !(mainActive() || anySel);
      var total = resultTotal();
      var comp = compareTotal();
      var totalHtml = (comp > total ? '<span class="qr-oldprice">' + money(comp) + '</span>' : '') + money(total);
      if (totalEl) {
        if (noFlash) { totalEl.innerHTML = totalHtml; }
        else { totalEl.classList.add('flash'); setTimeout(function () { totalEl.innerHTML = totalHtml; totalEl.classList.remove('flash'); }, 100); }
      }

      // Parcelamento (usa config global do tema)
      var instEl = stage.querySelector('[data-qr-installment]');
      if (instEl) {
        if (L.showInstallments && total > 0 && L.installmentsCount >= 2) {
          var per = Math.round(total / L.installmentsCount);
          instEl.innerHTML = 'em até <strong>' + L.installmentsCount + 'x de ' + money(per) + '</strong>' + (L.installmentsText ? ' ' + escapeHtml(L.installmentsText) : '');
          instEl.style.display = '';
        } else { instEl.style.display = 'none'; }
      }

      // Selo de frete grátis
      var fsEl = stage.querySelector('[data-qr-freeship]');
      if (fsEl) {
        if (L.showFreeship && L.freeShipCents > 0) {
          var truck = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="14" height="12"/><polygon points="15 8 19 8 22 11 22 16 15 16 15 8"/><circle cx="5.5" cy="18.5" r="2"/><circle cx="18.5" cy="18.5" r="2"/></svg>';
          if (total >= L.freeShipCents) {
            fsEl.innerHTML = truck + '<span><strong>Frete grátis</strong> liberado ✓</span>';
            fsEl.classList.add('ok');
          } else {
            fsEl.innerHTML = truck + '<span><strong>Frete grátis</strong> acima de ' + escapeHtml(L.freeShipLabel) + '</span>';
            fsEl.classList.remove('ok');
          }
          fsEl.style.display = '';
        } else { fsEl.style.display = 'none'; }
      }

      // Barra de progresso do brinde (contagem até o valor do brinde)
      var giftEl = stage.querySelector('[data-qr-gift]');
      if (giftEl) {
        if (L.showGift && L.giftCents > 0) {
          var reached = total >= L.giftCents;
          var pct = Math.min(100, Math.round(total / L.giftCents * 100));
          var msg = reached
            ? '🎁 <strong>Você ganhou seu brinde!</strong>'
            : 'Faltam <strong>' + money(L.giftCents - total) + '</strong> para o brinde 🎁';
          giftEl.innerHTML = '<div class="qr-giftbar-msg">' + msg + '</div>' +
            '<div class="qr-giftbar-track"><div class="qr-giftbar-fill" style="width:' + pct + '%"></div></div>';
          giftEl.classList.toggle('ok', reached);
          giftEl.style.display = '';
        } else { giftEl.style.display = 'none'; }
      }
    }

    function qrMainQty(delta) {
      if (!mainActive()) return;
      QR.main.qty = Math.max(1, Math.min(9, QR.main.qty + delta));
      var qEl = stage.querySelector('[data-qr-mainqty]');
      if (qEl) { qEl.classList.add('flash'); setTimeout(function () { qEl.textContent = QR.main.qty; qEl.classList.remove('flash'); }, 100); }
      syncSummary();
    }

    function qrRemoveMain() {
      if (!QR.main) return;
      QR.main.removed = true;
      var row = stage.querySelector('[data-qr-row="main"]');
      if (row) { row.classList.add('removing'); setTimeout(function () { row.classList.remove('removing'); row.classList.add('removed'); }, 320); }
      syncSummary();
    }

    function qrUndoMain() {
      if (!QR.main) return;
      QR.main.removed = false;
      var row = stage.querySelector('[data-qr-row="main"]');
      if (row) row.classList.remove('removed');
      syncSummary();
    }

    function qrToggleScent(id) {
      var c = QR.comps.filter(function (x) { return x.id === id; })[0];
      if (!c) return;
      c.selected = !c.selected;
      var card = stage.querySelector('[data-qr-comp="' + id + '"]');
      if (card) card.classList.toggle('added', c.selected);
      syncSummary();
    }

    /* ---- Animação de entrada do resultado ---- */
    function animateResult() {
      var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      var hdr = stage.querySelector('[data-qr-hdr]');
      var circle = stage.querySelector('.qr-circle-num');
      var stepH = stage.querySelector('.qr-step-h');
      var foot = stage.querySelector('[data-qr-foot]');
      if (reduce) {
        if (hdr) { hdr.style.opacity = '1'; hdr.style.transform = 'none'; }
        [circle, stepH, foot].forEach(function (el) { if (el) el.classList.add('in'); });
        return;
      }
      requestAnimationFrame(function () {
        if (hdr) { hdr.style.opacity = '1'; hdr.style.transform = 'translateY(0)'; }
        setTimeout(function () { if (circle) circle.classList.add('in'); }, 140);
        setTimeout(function () { if (stepH) stepH.classList.add('in'); }, 220);
        setTimeout(function () { if (foot) foot.classList.add('in'); }, 380);
      });
    }

    /* ============================================================
     * Add-to-cart — reusa o padrão do tema (cart-cross.js)
     * ============================================================ */
    function setNote(msg, isErr) {
      var note = stage.querySelector('[data-qr-note]');
      if (!note) return;
      note.textContent = msg || '';
      note.style.display = msg ? '' : 'none';
      note.classList.toggle('err', !!isErr);
    }

    function addRoutineToCart(btn) {
      var items = [];
      if (mainActive() && QR.main.variant_id) items.push({ id: Number(QR.main.variant_id), quantity: QR.main.qty });
      QR.comps.forEach(function (c) { if (c.selected && c.variant_id) items.push({ id: Number(c.variant_id), quantity: 1 }); });

      if (!items.length) {
        setNote(isDemo
          ? 'Modo de demonstração — vincule os produtos nos metaobjetos para ativar a compra.'
          : 'Estes produtos estão indisponíveis no momento.', true);
        return;
      }

      var addUrl = (window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js';
      btn.classList.add('loading');
      setNote('');

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify({ items: items, sections: ['minicart-form'], sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          if (state && state.status) {
            // erro (ex.: esgotado)
            setNote(state.description || (window.cartStrings && cartStrings.error) || 'Não foi possível adicionar. Tente novamente.', true);
            return null;
          }
          if (state && state.sections && state.sections['minicart-form']) {
            var doc = new DOMParser().parseFromString(state.sections['minicart-form'], 'text/html');
            var newForm = doc.querySelector('#minicart-form');
            var curForm = document.querySelector('#minicart-form');
            if (newForm && curForm) curForm.innerHTML = newForm.innerHTML;
          }
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (!cart) return;
          document.querySelectorAll('.cart-count').forEach(function (el) {
            el.innerHTML = el.classList.contains('cart-count-drawer')
              ? cart.item_count
              : (cart.item_count > 100 ? '~' : cart.item_count);
          });
          document.querySelectorAll('[data-cart-subtotal-price]').forEach(function (el) {
            try { el.innerHTML = money(cart.total_price); } catch (e) {}
          });
          var fs = document.querySelector('free-ship-progress-bar');
          if (fs && typeof fs.init === 'function') fs.init(cart.items_subtotal_price);
          var htp = document.querySelector('header-total-price');
          if (htp && typeof htp.updateTotal === 'function') htp.updateTotal(cart);

          var cn = document.querySelector('cart-notification');
          if (cn && typeof cn.cartAction === 'function') cn.cartAction();
          if (cn && typeof cn.open === 'function') { cn.open(); }
          else { window.location.href = (window.routes && routes.cart_url) ? routes.cart_url : '/cart'; }
          if (window.BlsLazyloadImg && BlsLazyloadImg.init) BlsLazyloadImg.init();
        })
        .catch(function () {
          setNote('Não foi possível adicionar à sacola. Tente novamente.', true);
        })
        .finally(function () { btn.classList.remove('loading'); });
    }

    /* ============================================================
     * Roteador
     * ============================================================ */
    var SCREENS = {
      intro: renderIntro, p1: renderP1,
      p2: renderP2, p3: renderP3, p4: renderP4, result: renderResult
    };

    function renderStep(step) {
      if (STEPS.indexOf(step) === -1) step = 'intro';
      QS.step = step;
      // barra de progresso só nas perguntas (some no intro e no resultado)
      setProgress(step === 'result' ? 0 : (PROGRESS_MAP[step] || 0));

      stage.innerHTML = '';
      var screen = document.createElement('div');
      screen.className = 'quiz-screen';
      if (step === 'intro') screen.classList.add('is-intro');
      screen.innerHTML = (SCREENS[step] || function () { return ''; })();
      stage.appendChild(screen);

      // ripple opcional nos CTAs
      screen.querySelectorAll('.quiz-cta,.qcard,.qchoice,.qr-sum-cta').forEach(function (b) {
        if (window.initRippleBtn) window.initRippleBtn(b, 'rgba(249,16,110,.14)');
      });

      if (step === 'result') {
        syncSummary(true);
        setTimeout(animateResult, 60);
      }
    }

    /* ---- Delegação de eventos (sem onclick inline) ---- */
    // Mostra o estado "selecionado" por um instante antes de avançar,
    // pra pessoa perceber o que escolheu (sem parecer travado).
    var SELECT_DELAY = 350;
    var picking = false;
    function pickThenAdvance(el, fn) {
      if (picking) return;              // ignora cliques repetidos no intervalo
      picking = true;
      // limpa seleção de irmãos e marca só o escolhido
      var siblings = el.parentNode ? el.parentNode.querySelectorAll('.qcard.selected, .qchoice.selected') : [];
      siblings.forEach(function (s) { s.classList.remove('selected'); });
      el.classList.add('selected');
      setTimeout(function () { picking = false; fn(); }, SELECT_DELAY);
    }

    stage.addEventListener('click', function (e) {
      var el = e.target.closest('[data-act]');
      if (!el || !stage.contains(el)) return;
      switch (el.dataset.act) {
        case 'start':    renderStep('p1'); break;
        case 'back':     renderStep(el.dataset.step); break;
        case 'concern':  pickThenAdvance(el, function () { selectConcern(el.dataset.key); }); break;
        case 'sens':     pickThenAdvance(el, function () { selectSensitivity(el.dataset.val); }); break;
        case 'routine':  pickThenAdvance(el, function () { selectRoutine(el.dataset.val); }); break;
        case 'scent':    pickThenAdvance(el, function () { selectScent(el.dataset.val); }); break;
        case 'restart':  QS = { step: 'intro', concern: null, manchaLoc: null, sensitivity: null, routine: null, scent: null }; renderStep('intro'); break;
        case 'main-inc':     qrMainQty(1); break;
        case 'main-dec':     qrMainQty(-1); break;
        case 'main-remove':  qrRemoveMain(); break;
        case 'main-undo':    qrUndoMain(); break;
        case 'scent-toggle': qrToggleScent(el.dataset.id); break;
        case 'addcart':      addRoutineToCart(el); break;
      }
    });

    renderStep('intro');
  }

  /* ---- Boot ---- */
  function boot() {
    document.querySelectorAll('[data-rs-quiz]').forEach(initQuiz);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector ? e.target.querySelector('[data-rs-quiz]') : null;
    if (r) initQuiz(r);
  });
})();
